export * from "./InfoIcon.styled";
